var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("vx-card", { staticClass: "mb-4" }, [
        _c(
          "div",
          { staticClass: "flex justify-between items-start flex-wrap gap-2" },
          [
            _c("div", [
              _c("h4", { staticClass: "mb-1" }, [
                _vm._v(_vm._s(_vm.$t("commission.title"))),
              ]),
              _c("small", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.$t("commission.hint"))),
              ]),
            ]),
            _c("b-form-select", {
              staticStyle: { width: "220px" },
              attrs: { options: _vm.statusFilters, size: "sm" },
              on: { change: _vm.load },
              model: {
                value: _vm.filterStatus,
                callback: function ($$v) {
                  _vm.filterStatus = $$v
                },
                expression: "filterStatus",
              },
            }),
          ],
          1
        ),
      ]),
      _c("vx-card", [
        _vm.isLoading
          ? _c("div", { staticClass: "text-center py-4 text-muted" }, [
              _vm._v(_vm._s(_vm.$t("common.loading"))),
            ])
          : !_vm.rows.length
          ? _c("div", { staticClass: "text-muted" }, [
              _vm._v(_vm._s(_vm.$t("commission.empty"))),
            ])
          : _c("table", { staticClass: "w-full admin-table" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", [_vm._v("ID")]),
                  _c("th", [_vm._v(_vm._s(_vm.$t("commission.influencer")))]),
                  _c("th", [_vm._v(_vm._s(_vm.$t("campaign.title")))]),
                  _c("th", { staticClass: "text-right" }, [
                    _vm._v(_vm._s(_vm.$t("commission.base"))),
                  ]),
                  _c("th", { staticClass: "text-right" }, [
                    _vm._v(_vm._s(_vm.$t("commission.discount"))),
                  ]),
                  _c("th", { staticClass: "text-right" }, [
                    _vm._v(_vm._s(_vm.$t("commission.amount"))),
                  ]),
                  _c("th", [_vm._v(_vm._s(_vm.$t("commission.hold_until")))]),
                  _c("th", [_vm._v(_vm._s(_vm.$t("status")))]),
                ]),
              ]),
              _c(
                "tbody",
                _vm._l(_vm.rows, function (c) {
                  return _c("tr", { key: c.id }, [
                    _c("td", [_vm._v(_vm._s(c.id))]),
                    _c("td", [
                      _vm._v(
                        " " + _vm._s(_vm._.get(c, "influencer.name")) + " "
                      ),
                      _c("small", { staticClass: "text-muted d-block" }, [
                        _vm._v(
                          _vm._s(_vm.$t("commission.order")) +
                            " #" +
                            _vm._s(c.order_id)
                        ),
                      ]),
                    ]),
                    _c("td", [_vm._v(_vm._s(_vm._.get(c, "campaign.name")))]),
                    _c("td", { staticClass: "text-right" }, [
                      _vm._v(_vm._s(_vm.money(c.base_amount_cents))),
                    ]),
                    _c("td", { staticClass: "text-right text-muted" }, [
                      _vm._v("- " + _vm._s(_vm.money(c.discount_amount_cents))),
                    ]),
                    _c("td", { staticClass: "text-right" }, [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.money(c.commission_amount_cents))),
                      ]),
                    ]),
                    _c("td", [
                      c.hold_until
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.formatDate(c.hold_until))),
                          ])
                        : _c("span", { staticClass: "text-muted" }, [
                            _vm._v("—"),
                          ]),
                    ]),
                    _c(
                      "td",
                      [
                        _c(
                          "vs-chip",
                          {
                            attrs: {
                              transparent: "",
                              color: _vm.statusColor(c.status),
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("commission.status_." + c.status)
                                ) +
                                " "
                            ),
                          ]
                        ),
                        c.adjustment_reason
                          ? _c(
                              "small",
                              { staticClass: "text-danger d-block" },
                              [_vm._v(_vm._s(c.adjustment_reason))]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ])
                }),
                0
              ),
            ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }